module.exports = __webpack_public_path__ + "img/2-4.7f92b6ef.png";